module.exports = __webpack_public_path__ + "static/img/logo.f98fa02a.png";